import { Box, Tab, Tabs } from "@mui/material";
import { NavigationBreadcrumbs, TabPanel } from "../../components";
import { useParams, useSearchParams } from "react-router-dom";

import { BACKEND_ROUTES } from "../../backendRoutes";
import { ContractDetailsSkeleton } from "./ContractDetailsSkeleton";
import { ContractManagement } from "./management";
import { ContractOverview } from "./overview";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { FetchErrorAlert } from "../../components/FetchErrorAlert";
import { useIsBasicRole } from "../../hooks";
import useSWR from "swr";
import { useState } from "react";

const CAMPAIGN_TABS = Object.freeze({
    overview: 0,
    management: 1,
});
export const ContractDetails = () => {
    const { uuid } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const isBasicRole = useIsBasicRole();

    const tab = searchParams.get("tab");
    const [currentTab, setCurrentTab] = useState(
        CAMPAIGN_TABS[tab] ?? CAMPAIGN_TABS.overview
    );

    const {
        data: contract,
        error: contractFetchError,
        mutate: mutateContract,
    } = useSWR(
        `${BACKEND_ROUTES.CONTRACT}/${uuid}?parentInfo=true&dataAllowances=true&cloverfieldData=true&statistics=true`
    );

    const handleTabChange = (_, newTab) => {
        setCurrentTab(newTab);
        setSearchParams({
            tab: newTab === CAMPAIGN_TABS.overview ? "overview" : "management",
        });
    };

    if (contractFetchError)
        return <FetchErrorAlert error={contractFetchError} />;
    if (!contract) return <ContractDetailsSkeleton />;

    return (
        <>
            <NavigationBreadcrumbs
                company={contract.Company}
                contract={contract}
            />
            {isBasicRole ? (
                <ContractManagement
                    contract={contract}
                    mutateContract={mutateContract}
                />
            ) : (
                <>
                    <Box
                        sx={{ mb: 1, borderBottom: 1, borderColor: "divider" }}
                    >
                        <Tabs
                            value={currentTab}
                            onChange={handleTabChange}
                            sx={{ height: 60 }}
                        >
                            <Tab
                                label="Campaign Overview"
                                icon={<DashboardIcon />}
                                iconPosition="start"
                            />
                            <Tab
                                label="Campaign Management"
                                icon={<EditNoteIcon />}
                                iconPosition="start"
                            />
                        </Tabs>
                    </Box>
                    <TabPanel value={currentTab} index={0}>
                        <ContractOverview contract={contract} />
                    </TabPanel>
                    <TabPanel value={currentTab} index={1}>
                        <ContractManagement
                            contract={contract}
                            mutateContract={mutateContract}
                        />
                    </TabPanel>
                </>
            )}
        </>
    );
};
